<template>
  <div id="app">
    <leftNav v-if="nav_show"></leftNav>
    <homeLeftNav v-if="home_nav_show"></homeLeftNav>
    <router-view v-on:mobileNav="mobileNav" v-on:homeMobileNav="homeMobileNav" v-on:mobileFooter="mobileFooter"></router-view>
    <comFooter v-if="footer_show"></comFooter>
  </div>
</template>

<script>
  import mobileNav from './components/nav/leftNav'
  import homeMobileNav from './components/nav/homeLeftNav'
  import mobileFooter from './components/nav/comFooter'
 
  export default {
    name: 'App',
    data() {
      return {
        nav_show: true,
        home_nav_show: true,
        footer_show:true
      }
    },
    components: {
      'leftNav': mobileNav,
      'homeLeftNav': homeMobileNav,
      'comFooter':mobileFooter
    },
    methods: {
      // 是否显示头部
      mobileNav: function(bool) {
        this.nav_show = bool;
      },
      //是否显示首页头部
      homeMobileNav: function(bool) {
        this.home_nav_show = bool;
      },
      // 是否显示底部（默认显示）
      mobileFooter:function(bool){
        this.home_nav_show = bool;
      }
    },

  }
</script>

<style>
  #app {
    font-family:PingFang SC;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    /*抗文字图标锯齿*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
   /* width: 7.5rem; */
    margin: 0 auto;
  }
  .page-nav-paading{
    padding: 0.88rem 0 0 0;
  }
*{
  margin: 0;
  padding: 0;
}
ul li{
  list-style: none;
}
a{
  text-decoration: none;
}
  .flex-flex {
    display: flex;
    justify-content: space-between;
  }

  .flex-start {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .flex-start-start {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .flex-end-start {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
  }
  .flex-end {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .flex-around {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .flex-start-between {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .flex-end-between {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
  /* 超出省略号显示 */
  .text-ovflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .text-ovflow2{
    text-overflow: ellipsis;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .text-ovflow3{
    text-overflow: ellipsis;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  /* banner */
  .business-banner-panel{
    width: 100%;
    height: 8.28rem;
    background-size: cover!important;
  }
  /* 标题 */
  .black-business-item-title-cn{
  font-size:0.42rem;
  font-weight:bold;
  line-height:0.72rem;
  color:rgba(53,51,64,1);
  }
  .black-business-item-title-en{
    font-size:0.32rem;
    font-weight:400;
    color:rgba(53,51,64,0.80);
    padding-top: 0.11rem;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue